module.exports = "<app-youtube-player [videoId]=\"videoId\"></app-youtube-player>"